import { Color, ProductColorItem, ProductMeta, Size } from '@proto/store/api/common/common';
import { Urls } from '@helper/urls';

export class GridItem {
  constructor(
    public hash: string,
    public link: string,
    public meta: ProductMeta | undefined,
    public colorId: string,
    public colorName: string,
    public colors: Color[],
    public sizes: Size[],
    public isClothHash: boolean
  ) {}

  static toGridItems(colorItem: ProductColorItem | undefined, listMode = true, displaySizes = true): GridItem[] {
    return (
      (listMode
        ? colorItem?.items.flatMap(i => {
            return !i.listHash
              ? i.colors.map(
                  c =>
                    new GridItem(
                      c.listHash || c.clothHash,
                      Urls.fromMeta(i.meta, c.color?.id ?? ''),
                      i.meta,
                      c.color?.id ?? '',
                      c.color?.name ?? '',
                      [c.color as Color],
                      [],
                      // starts with 0360 means it is a cloth hash
                      !c.listHash || c.listHash.startsWith('0360')
                    )
                )
              : [
                  new GridItem(
                    i.listHash || i.clothHash,
                    Urls.fromMeta(i.meta),
                    i.meta,
                    '',
                    '',
                    i.colors.map(c => c.color as Color),
                    [],
                    // starts with 0360 means it is a cloth hash
                    !i.listHash || i.listHash.startsWith('0360')
                  ),
                ];
          })
        : colorItem?.items.flatMap(i =>
            i.colors.length
              ? i.colors.map(
                  item =>
                    new GridItem(
                      item.clothHash || item.listHash,
                      Urls.fromMeta(i.meta, item.color?.id ?? ''),
                      i.meta,
                      item.color?.id ?? '',
                      item.color?.name ?? '',
                      [],
                      displaySizes ? item.sizes.filter(s => s.stockRemind || s.num) : [],
                      !!item.clothHash
                    )
                )
              : [
                  new GridItem(
                    i.clothHash || i.listHash,
                    Urls.fromMeta(i.meta, ''),
                    i.meta,
                    '',
                    '',
                    [],
                    [],
                    !!i.clothHash
                  ),
                ]
          )) ?? []
    );
  }
}
